import axios from 'axios' 
import { baseUrl } from './tool'
let API_BASE_URL = baseUrl + '/keer/api/'

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  validateStatus: (status) => {
    return status >= 200 && status < 500
  }
})

// request
service.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

// response
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.errorCode == 0) {
      return res
    } else {
      return Promise.reject(res.message || 'error')
    }
  },
  error => {
    return Promise.reject(error)
  }
)

export default service